import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import DashboardLayout from './components/layout/DashboardLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import BoundBook from './pages/BoundBook';
import Acquisition from './pages/Acquisition';
import Disposition from './pages/Disposition';
import IncomingOrders from './pages/IncomingOrders';
import ReceivePendingOrder from './pages/ReceivePendingOrder';
import Contacts from './pages/Contacts';
import Lookups from './pages/Lookups';
import Settings from './pages/Settings';
import TenantUsers from './pages/Users';
import Tenants from './pages/Admin/Tenants';
import Users from './pages/Admin/Users';
import '@questlabs/react-sdk/dist/style.css';

const ProtectedRoute = ({ children, adminOnly = false, requireTenant = false }) => {
  const { user, tenant, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-slate-50 dark:bg-slate-950">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary-600 border-t-transparent"></div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== 'SUPER_ADMIN') return <Navigate to="/" replace />;
  if (requireTenant && !tenant) return <Navigate to="/admin/tenants" replace />;

  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="bound-book" element={<ProtectedRoute requireTenant><BoundBook /></ProtectedRoute>} />
        <Route path="acquisition" element={<ProtectedRoute requireTenant><Acquisition /></ProtectedRoute>} />
        <Route path="incoming-orders" element={<ProtectedRoute requireTenant><IncomingOrders /></ProtectedRoute>} />
        <Route path="incoming-orders/:id" element={<ProtectedRoute requireTenant><ReceivePendingOrder /></ProtectedRoute>} />
        <Route path="disposition" element={<ProtectedRoute requireTenant><Disposition /></ProtectedRoute>} />
        <Route path="contacts" element={<ProtectedRoute requireTenant><Contacts /></ProtectedRoute>} />
        <Route path="lookups" element={<ProtectedRoute requireTenant><Lookups /></ProtectedRoute>} />
        <Route path="users" element={<ProtectedRoute requireTenant><TenantUsers /></ProtectedRoute>} />
        <Route path="settings" element={<Settings />} />

        {/* Admin Routes */}
        <Route path="admin/tenants" element={<ProtectedRoute adminOnly><Tenants /></ProtectedRoute>} />
        <Route path="admin/users" element={<ProtectedRoute adminOnly><Users /></ProtectedRoute>} />

        <Route path="*" element={<div className="p-8">Page under construction</div>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;